export default "__VITE_ASSET__BE_47yIF__"